import { createContext } from 'react';

export interface IConversationContext {
  CONVERSATION_ID: string;
}

const initialState: IConversationContext = {
  CONVERSATION_ID: '',
};

export default createContext<IConversationContext>(initialState);
